import { render, staticRenderFns } from "./mijn.vue?vue&type=template&id=48d0056e"
import script from "./mijn.vue?vue&type=script&lang=js"
export * from "./mijn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports